var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',{directives:[{name:"accent",rawName:"v-accent",value:(_vm.header),expression:"header"}],class:{
    'text-xl': !_vm.smaller,
    'text-l': _vm.smaller,
    uppercase: _vm.uppercase,
    underline: _vm.underline
  }})}
var staticRenderFns = []

export { render, staticRenderFns }